export enum EChangePaymentDateActions {
    SET_CURRENT_DATE = 'CHANGE_PAYMENT_DATE/CURRENT_DATE/SET',
    SET_SELECTED_DAY = 'CHANGE_PAYMENT_DATE/SELECTED_DAY/SET',
    SET_IS_AUTO_ACTIVATE = 'CHANGE_PAYMENT_DATE/IS_AUTO_ACTIVATE/SET',
    SET_IS_LOADING = 'CHANGE_PAYMENT_DATE/PAY_SUM/IS_LOADING',
    SET_PAY_SUM = 'CHANGE_PAYMENT_DATE/PAY_SUM/SET',
    SET_CHANGE_DATE = 'CHANGE_PAYMENT_DATE/CHANGE_DATE/SET',
    SET_LOADING_DAY_INFO_STATUS = 'CHANGE_PAYMENT_DATE/DAY_INFO_STATUS/SET',
    SET_POPUP_STATE = 'CHANGE_PAYMENT_DATE/POPUP_STATE/SET',
    SET_CLOSE_POPUP = 'CHANGE_PAYMENT_DATE/POPUP/CLOSE',
}

export interface IDate {
    day: number,
    month: number,
}

export type { TSetChangeDate } from './setChangeDate';
export { default as setChangeDate } from './setChangeDate';
export type { TSetClosePopup } from './setClosePopup';
export { default as setClosePopup } from './setClosePopup';
export type { TSetCurrentDate } from './setCurrentDate';
export { default as setCurrentDate } from './setCurrentDate';
export type { TSetIsAutoActivate } from './setIsAutoActivate';
export { default as setIsAutoActivate } from './setIsAutoActivate';
export type { TSetIsLoading } from './setIsLoading';
export { default as setIsLoading } from './setIsLoading';
export type { TLoadingStatus } from './setLoadingDayInfoStatus';
export type { TSetLoadingDayInfoStatus } from './setLoadingDayInfoStatus';
export { default as setLoadingDayInfoStatus } from './setLoadingDayInfoStatus';
export type { TSetPaySum } from './setPaySum';
export { default as setPaySum } from './setPaySum';
export type { TSetPopupState } from './setPopupState';
export { default as setPopupState } from './setPopupState';
export type { TSetSelectedDay } from './setSelectedDay';
export { default as setSelectedDay } from './setSelectedDay';
